import Blogview from "../Previews/Ship/Terms/Blogview";
import BlogThumbnailPreview from "../Previews/Ship/ThumbnailPreview/BlogPreview";

export const blogDetails = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English Thumbnail Image",
          key: "image",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload English Thumbnail Image Width:700, Height:390",
        },
        {
          title: "Simplified Chinese Thumbnail Image",
          key: "simplified_chinese_image",
          className: "col-lg-3",
          placeholder: "Upload Simplified Chinese Thumbnail Image Width:700, Height:390",
          type: "file",
        },
        {
          title: "Traditional Chinese Thumbnail Image",
          key: "traditional_chinese_image",
          className: "col-lg-3",
          placeholder: "Upload Traditional Chinese Thumbnail Image Width:700, Height:390",
          type: "file",
        },
        {
          title: "Bahasa Thumbnail Image",
          key: "bahasa_image",
          className: "col-lg-3",
          placeholder: "Upload Bahasa Thumbnail Image Width:700, Height:390",
          type: "file",
        },
        {
          title: "English Thumbnail Image Alt",
          key: "thumbnail_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Thumbnail Image Alt",
          key: "thumbnail_simplified_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Thumbnail Image Alt",
          key: "thumbnail_traditional_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Thumbnail Image Alt",
          key: "bahasa_thumbnail_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "textarea",
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "textarea",
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "textarea",
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "input",
        },

      ],
      preview: (activetab, cardData) => (
        <BlogThumbnailPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 5,
      fields: [
        {
          title: "English Header",
          key: "description",
          className: "col-lg-3",

          type: "editor",
          height: "300px",
        },
        {
          title: "Simplified Chinese Header",
          key: "simplified_chinese_description",
          className: "col-lg-3",

          type: "editor",
          height: "300px",
        },
        {
          title: "Traditional Chinese Header",
          key: "traditional_chinese_description",
          className: "col-lg-3",

          type: "editor",
          height: "300px",
        },
        {
          title: "Bahasa Header",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-3",
          placeholder: "Upload Page Image",
          type: "file",
        },
        {
          title: "Simplified Chinese Page Image",
          key: "simplified_chinese_image",
          className: "col-lg-3",
          placeholder: "Upload Simplified Chinese Page Image ",
          type: "file",
        },
        {
          title: "Traditional Chinese Page Image",
          key: "traditional_chinese_image",
          className: "col-lg-3",
          placeholder: "Upload Traditional Chinese Page Image ",
          type: "file",
        },
        {
          title: "Bahasa Page Image",
          key: "bahasa_image",
          className: "col-lg-3",
          placeholder: "Upload Bahasa Page Image ",
          type: "file",
        },
       {
          title: "English Page Image Alt",
          key: "page_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Page Image Alt",
          key: "page_simplified_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Page Image Alt",
          key: "page_traditional_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Page Image Alt",
          key: "bahasa_page_image_alt",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "English Footer",
          key: "description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Simplified Chinese Footer",
          key: "simplified_chinese_description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Traditional Chinese Footer",
          key: "traditional_chinese_description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Bahasa Footer",
          key: "bahasa_description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },


      ],
      preview: (activetab, cardData) => (
        <Blogview activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
